import { render } from "./CosmetischeTandheelkunde.vue?vue&type=template&id=0784f15d&scoped=true"
import script from "./CosmetischeTandheelkunde.vue?vue&type=script&lang=js"
export * from "./CosmetischeTandheelkunde.vue?vue&type=script&lang=js"

import "./CosmetischeTandheelkunde.vue?vue&type=style&index=0&id=0784f15d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0784f15d"]])

export default __exports__